/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 31/07/13
 * Time: 10:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('Service_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource( baseUrl + 'rest/services/:id' , {} ,
            {
                query: { method: 'GET', isArray: true },
                get:   { method: 'GET' },
                getDeleted: { method: 'GET', isArray: true , url:baseUrl+'rest/services/deleted'},
                getEnabledServiceSettingReserveWithGoogle: { method: 'GET', isArray: true, url:baseUrl+'rest/services/serviceSettingReserveWithGoogle/isVisible'},
                createWithPartnerServiceSettings: { method: 'POST', url: baseUrl + 'rest/services/create-with-partner-service-settings'}
            }
        );
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('Service',["Service_Resource","ImageData","ServiceData","CategoryData","CompanyImageData","ProductData",
        function (Service_Resource,ImageData,ServiceData,CategoryData,CompanyImageData,ProductData)
    {

        var Service = function (resource,parentCategory)
        {
            this.id = null;
            this.serviceSettingsReserveWithGoogleId = null;
            this.isDeleted;
            this.label = "";
            this.labelShort = "";
            this.description= "";
            this.isPackage= false;
            this.isOnHome= false;
            this.homeOrder= 0;
            this.price= null;
            this.hasInternetPrice= false;
            this.hasMandatoryPayment= false;
            this.internetPrice= null;
            this.duration= null;
            this.hasItnDuration= null;
            this.itnDuration= null;
            this.image = null;
            this.companyImage = null;
            this.specificImage = null;
            this.nbHrsNeeded = null;
            this.nbPrsNeeded = null;
            this.isVisibleOnWebSite = true;//Default;
            this.isBookableOnWebSite = true;//Default;
            this.subServices = [];
            this.products = [];
            this._productsId = [];
            this.images = [];
            this.cures = [];
            this.version = null;
            this.subWidgets = null;
            this.imgWidget = null;
            this.style = null;

            if (resource !== undefined && resource != null)
            {
                this.loadObject(resource,parentCategory);
            }
            else
                if (parentCategory !== undefined && parentCategory != null)
                {
                    this.parentCategory = parentCategory;
                }

            ServiceData.add(this);
        };
        Service.prototype.loadObject = function(object,parentCategory)
        {
            //Assume here than the object in parameter contains only id (must load them)
            if (!this.id)
                this.id = object.id;
            this.serviceSettingsReserveWithGoogleId = object.serviceSettingsReserveWithGoogleId;
            this.isDeleted = object.isDeleted;
            this.parentCategoryId =  object.parentCategoryId;
            this.label = object.label;
            this.labelShort = object.labelShort;
            this.description= object.description;
            this.isPackage= object.isPackage;
            this.isOnHome= object.isOnHome;
            this.homeOrder= object.homeOrder;
            this.price= object.price;
            this.hasInternetPrice= object.hasInternetPrice;
            this.hasMandatoryPayment= object.hasMandatoryPayment;
            this.internetPrice= object.internetPrice;
            this.duration= object.duration;
            this.hasItnDuration = object.hasItnDuration;
            this.itnDuration= object.itnDuration;
            this.imageId =  object.imageId;
            this.companyImageId =  object.companyImageId;
            this.specificImage = object.specificImage;
            this.nbHrsNeeded = object.nbHrsNeeded;
            this.nbPrsNeeded = object.nbPrsNeeded;
            this.isVisibleOnWebSite = object.isVisibleOnWebSite;
            this.isBookableOnWebSite = object.isBookableOnWebSite;
            this.nbPrsNeeded = object.nbPrsNeeded;
            this.subWidgets = object.subWidgets;
            this.imgWidget = object.imgWidget;
            this.style = object.style;

            if (parentCategory!==undefined && parentCategory!=null)
            {
                this.parentCategory = parentCategory;
            }
            this.subServices = [];
            if (object.subServices)
            {

                for (var j=0;j< object.subServices.length;j++)
                {
                    var service = new Service(object.subServices[j],parentCategory);//not linked to not have it inside cat
                    this.subServices.push(service);
                }
            }
            if (object.productsId)
                this._productsId =object.productsId;
            if (object.version)
                this.version = object.version;
        };
        Service.prototype.getObjectResource = function(isSub)
        {
            var rsService = new Service_Resource();
            rsService.id = this.id;
            rsService.serviceSettingsReserveWithGoogleId = this.serviceSettingsReserveWithGoogleId;
            rsService.isDeleted = this.isDeleted;
            rsService.label =this.label;
            rsService.labelShort = this.labelShort;
            if (this.image)
                rsService.imageId = this.image.id;
            if (this.companyImage)
                rsService.companyImageId = this.companyImage.id;
            rsService.specificImage = this.specificImage;
            rsService.description = this.description ;
            rsService.isPackage = this.isPackage ;
            rsService.isOnHome = this.isOnHome ;
            rsService.homeOrder = this.homeOrder ;
            rsService.price= this.price;
            rsService.hasInternetPrice = this.hasInternetPrice ;
            rsService.hasMandatoryPayment = this.hasMandatoryPayment ;
            rsService.internetPrice= this.internetPrice;
            rsService.duration = this.duration;
            rsService.itnDuration = this.itnDuration;
            rsService.hasItnDuration = this.hasItnDuration;
            rsService.nbHrsNeeded = this.nbHrsNeeded;
            rsService.nbPrsNeeded = this.nbPrsNeeded;
            rsService.isVisibleOnWebSite = this.isVisibleOnWebSite;
            rsService.isBookableOnWebSite = this.isBookableOnWebSite;
            rsService.subWidgets = this.subWidgets;
            rsService.imgWidget = this.imgWidget;
            rsService.style = this.style;
            //needPhysicalResource &&  needHumanResource MANAGED BY SERVER
            if ((isSub==undefined || !isSub) && this.parentCategory!=null)//dont save it to not link it to server
                rsService.parentCategoryId = this.parentCategory.getId();

            rsService.subServices = [];
            for (var i=0;i< this.subServices.length;i++)
                rsService.subServices.push(this.subServices[i].getObjectResource(true));

            rsService.productsId = [];
            for (var i=0;i< this.products.length;i++)
                rsService.productsId.push(this.products[i].getId());
            return rsService;
        };

        Service.prototype.loadRef =  function()
        {
            if (this.imageId)
                this.image = ImageData.getById(this.imageId);
            if (this.companyImageId)
                this.companyImage = CompanyImageData.getById(this.companyImageId);
            if (this.parentCategory==null && this.parentCategoryId)
                this.parentCategory = CategoryData.getById(this.parentCategoryId);
            for (var i=0;i< this.subServices.length;i++)
                this.subServices[i].parentCategory = this.parentCategory;
            if (this._productsId)
            {
                var newProducts = [];
                for (var i=0;i<this._productsId.length;i++)
                {
                    var product =  ProductData.getById(this._productsId[i]);
                    if (product!=null)
                        newProducts.push(product);
                }
                this.products = newProducts;
            }
        };
        Service.prototype.getId = function()
        {
            return this.id;
        };
        Service.prototype.setId = function(id)
        {
            this.id = id;
        }
        Service.prototype.getLabel = function()
        {
            return this.label;
        }
        Service.prototype.reload = function(endFunction)
        {
            var serviceSrv = this.getObjectResource();
            var service = this;
            if (this.getId()!=null)
                serviceSrv.$get({id:this.getId()}, //params
                    function (data) {   //success
                        service.loadObject(data);
                        if (endFunction !=undefined)
                            endFunction(service);
                    },
                    function (data) {   //failure
                        //error handling goes here
                        //TODO
                    });
        }

        Service.prototype.isDescendantOf = function (category, parentService) {
            let isDescendantOf = false;
            if (this.parentCategory === category) {
                isDescendantOf = true;
            } else if (this.parentCategory) {
                isDescendantOf = this.parentCategory.isDescendantOf(category);
            } else if (parentService) {
                isDescendantOf = parentService.isDescendantOf(category);
            }

            return isDescendantOf;
        }

        return Service;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('ServiceSrv',["$log","HumanResourceData","HumanResourceSrv","Service_Resource","Service","CategoryData","UserActionData","ServiceData","ServerSrv",
        function ($log,HumanResourceData,HumanResourceSrv,Service_Resource,Service,CategoryData,UserActionData,ServiceData,ServerSrv)
    {
        var  serviceSrv = {};

        serviceSrv.save =  function(service,successFunction,errorFunction) {
            ServerSrv.startSavingProcess(serviceSrv.saveSync, service, successFunction, errorFunction);
        };

        serviceSrv.saveSync = function (service, successFunction, errorFunction) {
            var ServiceRes = service.getObjectResource();
            ServiceRes.$save({}, //no params
                function (serviceRes) {
                    try {
                        serviceSrv.saveSuccessCallback(serviceRes, service, successFunction);
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    try {
                        if (errorFunction !== undefined) {
                            errorFunction(data);
                        }
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );
        };

        serviceSrv.createWithPartnerServiceSettings =  function(service, activationByPartnerLabel, settingsByPartnerLabel, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(serviceSrv.createWithPartnerServiceSettingsSync, service, activationByPartnerLabel, settingsByPartnerLabel, successFunction, errorFunction);
        };

        serviceSrv.createWithPartnerServiceSettingsSync = function (service, activationByPartnerLabel, settingsByPartnerLabel, successFunction, errorFunction) {
            var ServiceRes = service.getObjectResource();
            ServiceRes.activationByPartnerLabel = activationByPartnerLabel;
            ServiceRes.settingsByPartnerLabel = settingsByPartnerLabel;
            ServiceRes.$createWithPartnerServiceSettings({}, //no params
                function (serviceRes) {
                    try {
                        serviceSrv.saveSuccessCallback(serviceRes, service, successFunction);
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    try {
                        if (errorFunction !== undefined) {
                            errorFunction(data);
                        }
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );
        };

        serviceSrv.saveSuccessCallback = function (serviceRes, service, successFunction) {
            if (service.id == null) {
                service.setId(serviceRes.id);
            }
            if (!service.version || (serviceRes.version && serviceRes.version > service.version)) {
                service.version = serviceRes.version;
            }
            if (serviceRes.subServicesId)
                for (var j = 0; j < serviceRes.subServicesId.length; j++) {
                    service.subServices[j].setId(serviceRes.subServicesId[j]);
                }

            if (successFunction !== undefined) {
                successFunction(serviceRes);
            }
        };

        serviceSrv.remove =  function(service,successFunction,errorFunction)
        {
            ServiceData.remove(service);
            ServerSrv.startSavingProcess(serviceSrv.removeSync, service, successFunction, errorFunction);
        };
        serviceSrv.removeSync =  function(service,successFunction,errorFunction)
        {
            var serviceRes = new Service_Resource();
            serviceRes.$remove({id:service.getId()}, //params : id
                function (data) {
                    try{
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        }
        serviceSrv.restore =  function(service,successFunction,errorFunction)
        {
            ServiceData.restore(service);
            ServerSrv.startSavingProcess(serviceSrv.restoreSync, service, successFunction, errorFunction);
        };
        serviceSrv.restoreSync =  function(service,successFunction,errorFunction)
        {
            //$timeout (function () {

            var serviceRes = service.getObjectResource();
            serviceRes.$save({}, //params : id
                function (data) {
                    try{
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        }

        serviceSrv.loadEnabledServiceSettingsReserveWithGoogleViews = function (successFunction, errorFunction) {
            Service_Resource.getEnabledServiceSettingReserveWithGoogle(
                {},
                function (data) {
                    if (successFunction!== undefined)
                        successFunction(data);
                },
                function (data) {
                    if (errorFunction !== undefined)
                        errorFunction(data);
                });
        };

        serviceSrv.query = function(successFunction,errorFunction)
        {
            Service_Resource.getDeleted(
                {}, //params
                function (data) {   //success

                    ServiceData.deletedServices = [] ;
                    for (var i=0;i< data.length;i++)
                        new Service(data[i]);//Auto Add to ServiceData

                    if (successFunction!== undefined )
                        successFunction(ServiceData.indexServices);
                },
                function (data) {   //failure
                    $log.error("Service_Resource.getDeleted error");
                    $log.error(data);
                    if (errorFunction!== undefined)
                        errorFunction(data);

                });
        }
        serviceSrv.loadRef =  function()
        {
            var services = ServiceData.indexServices;
            for (var i=0;i<services.length;i++)
                services[i].loadRef();

        }
        serviceSrv.updateLocally =  function(id,object)
        {
            var service =  null;
            var category = CategoryData.getById(object.parentCategoryId);
            if (category!=null)
                service = category.getServiceById(id);
            if (service!=null)
            {
                service.loadObject(object,category);
            }
            return service
        }
        serviceSrv.addLocally =  function(id,object)
        {
            var service =  null;
            var category = CategoryData.getById(object.parentCategoryId);
            if (category!=null)
            {
                service  = new Service(object,category);
                service.id = id;
                category.addService();

            }
            return null;

        }
        serviceSrv.removeLocally =  function(id,object)
        {
            var service =  null;
            var category = CategoryData.getById(object.parentCategoryId);
            if (category!=null)
                service = category.getServiceById(id);
            if (service!=null)
                category.removeService(service);
            return service;
        }

        return serviceSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('ServiceData',["$log", function ($log)
    {
        var  serviceData =
        {
            indexServices : [], //Used as Index
            deletedServices : []
        };
        serviceData.getById =  function(serviceId)
        {
            for (var i=0;i<this.indexServices.length;i++)
                if (this.indexServices[i].id==serviceId)
                    return this.indexServices[i];
            return null;
        }
        serviceData.getByIndex =  function(servIndex)
        {
            if (servIndex>=0 && servIndex<this.indexServices.length)
            {
                return this.indexServices[servIndex];
            }
            else
                return null;
        }
        serviceData.getIndexOf =  function(service)
        {
            if (service)
                return this.indexServices.indexOf(service);
            return -1;
        }
        serviceData.add =  function(service)
        {
            this.indexServices.push(service);
            if (service.isDeleted)
            {
                var index = this.deletedServices.indexOf(service)
                if (index==-1)
                    this.deletedServices.push(service);
            }
            return this.indexServices.length-1;
        }
        serviceData.remove =  function(service) //Soft Remove
        {
            var index =  this.deletedServices.indexOf(service);
            if (index==-1)
            {
                this.deletedServices.push(service)
                service.isDeleted=true;
            }

        }
        serviceData.restore =  function(service) //Soft Remove
        {
            var index =  this.deletedServices.indexOf(service);
            if (index!=-1)
            {
                this.deletedServices.splice(index,1)
                service.isDeleted=false;
            }

        }
        serviceData.clear =  function()
        {
            serviceData.indexServices = [];
            serviceData.deletedServices = [];
        }
        serviceData.getDeletedList =  function()
        {
            return serviceData.deletedServices;
        }

        return serviceData;
    }
    ]);



// WEBPACK FOOTER //
// ./js/services/models/Service.js